import React from 'react';
import Lottie from 'react-lottie';
// eslint-disable-next-line import/no-unresolved
import bulkUploading from '../../../../assets/lottieJSON/uploader.json';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: bulkUploading,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const AddToSeqLoader = props => {
  const { loadingMessage } = props;

  return (
    <div className="generatingPreview">
      <div className="imageCont">
        <Lottie
          options={defaultOptions}
          width={200}
          height={155}
          style={{ margin: '0 auto' }}
          speed={0.7}
        />
        <div className="generatingPreviewText">{loadingMessage}</div>
      </div>
    </div>
  );
};

export default AddToSeqLoader;
export { AddToSeqLoader };
